module.exports = __webpack_public_path__ + "static/media/bid.2e0e717d.svg";